import { globalConf, conf } from './conf.js';
import { convincely, reusable } from './convincely.js';
import { http } from './http.js';
const isRemote = /^https?:\/\//;
export class CacheService {
    constructor(localConf) {
        this.conf = localConf || conf;
        this.imageCaches = {};
        this.jsonCaches = {};
        this.iconCaches = localConf ? {} : convincely.cache;
        this.preloadIcon = this.preloadIcon.bind(this);
        this.preloadImage = this.preloadImage.bind(this);
    }
    preload(src, cache, request = http.getContent, base = this.conf.baseUrl) {
        if (!cache[src]) {
            const calcUrl = isRemote.test(src) ? src : base + src;
            cache[src] = request(calcUrl, undefined).then((content) => (cache[src] = content));
        }
        return cache[src];
    }
    preloadIcon(src) {
        return this.preload(src, this.iconCaches, http.getContent);
    }
    preloadIcons(icons) {
        icons.forEach(this.preloadIcon);
    }
    preloadJson(src, base = this.conf.baseUrl) {
        return this.preload(src, this.jsonCaches, http.getJson, base);
    }
    preloadImage(src) {
        const img = this.imageCaches[src] || new Image();
        if (!img.src) {
            img.src = isRemote.test(src) ? src : this.conf.baseUrl + src;
            this.imageCaches[src] = img;
        }
        return img;
    }
    preloadImages(images) {
        return images.map(this.preloadImage);
    }
}
export const cacheService = (globalConf.consumerCaches[conf.$appName] = reusable('cacheService', new CacheService(), conf.$appName));
//# sourceMappingURL=cache.js.map